<template>
  <base-material-card
    color="primary"
    icon="mdi-file-compare"
    inline
    class="px-5 py-5"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        Adicionar Validação de Baixas
      </div>
    </template>

    <v-form class="pt-5">
      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              id="titulo-validacao-baixas"
              label="Título"
              outlined
              :error-messages="errors"
              v-model="titulo"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters class="mx-4" id="periodo-base-validacao-baixas">
        <v-col class="pb-0 pt-1" sm="5" cols="12">
          <v-menu
            v-model="menuPickerBaseInicio"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider 
                v-slot="{ errors }"
                rules="required|min:10"
              >
                <v-text-field
                  :error-messages="errors"
                  class="pt-0"
                  v-mask="'##/##/####'"
                  v-model="dataFormattedBaseInicio"
                  label="Data Base"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataBaseInicio = parseDate(dataFormattedBaseInicio);"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataBaseInicio"
              @input="menuPickerBaseInicio = false; dataFormattedBaseInicio = formatDate(dataBaseInicio);"
              locale="pt-br"
            />
          </v-menu>
        </v-col>
        <v-col class="text-center py-4" style="white-space: nowrap !important;" sm="1" cols="12">
          <span style="color: rgba(0, 0, 0, 0.54); font-size:15px">até</span> 
        </v-col>
        <v-col class="pb-0 pt-1" sm="5" cols="12">
          <v-menu
            v-model="menuPickerBaseFim"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider 
                v-slot="{ errors }" 
                rules="required|min:10"
              >
                <v-text-field
                  :error-messages="errors"
                  class="pt-0"
                  v-mask="'##/##/####'"
                  v-model="dataFormattedBaseFim"
                  label="Data Base"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataBaseFim = parseDate(dataFormattedBaseFim);"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataBaseFim"
              @input="menuPickerBaseFim = false; dataFormattedBaseFim = formatDate(dataBaseFim);"
              locale="pt-br"
            />
          </v-menu>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>

import dateFormatterMixins from '@/mixins/dateFormatterMixins';

export default {

  name: 'ParametrosValidacaoBaixas',

  mixins: [dateFormatterMixins],

  data() {
    return {
      titulo: '',
      menuPickerBaseInicio: false,
      menuPickerBaseFim: false,
      dataFormattedBaseInicio: '',
      dataBaseInicio: '',
      dataFormattedBaseFim: '',
      dataBaseFim: '',
    };
  },

  methods: {
    
    exportData() {
      return {
        nome: this.titulo,
        data_base_inicio: this.dataBaseInicio,
        data_base_fim: this.dataBaseFim
      }
    }
  }
};

</script>